// extracted by mini-css-extract-plugin
module.exports = {"sortableItem":"style_sortableItem__uXsLf","name":"style_name__1lT_b"};